import Loading from "@/pages/Loading";
import { db } from "@/shared/firbase";
import { FlexColumn, FlexRow } from "@/style/GlobalStyle";
import {
  collection,
  DocumentData,
  getDocs,
  orderBy,
  query,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import SharedURL from "../SharedURL";
import { Content, Main, MainTitle, TitleDiv } from "./style";
import { useTranslation } from "react-i18next";
import i18n from "@/lang/i18n";

const Contents = ({ name }: { name: string }) => {
  const dbCollection = collection(db, name);
  const { t } = useTranslation();
  const rankDBCollection = query(
    collection(db, `${name}-rank`),
    orderBy("count", "desc")
  );
  const [data, setData] = useState<DocumentData[]>([]);
  const [rank, setRank] = useState<DocumentData[]>([]);
  const navigate = useNavigate();

  const getData = async () => {
    //  데이터베이스에서 가져오기
    const data = await getDocs(dbCollection);
    const rankData = await getDocs(rankDBCollection);
    //  가져와서 배열에 집어넣기
    setData(data.docs.map((doc) => doc.data()).sort(() => Math.random() - 0.5));
    setRank(rankData.docs.map((doc) => doc.data()));
    return;
  };

  useEffect(() => {
    getData();
  }, []);

  const onGameStart = () => {
    navigate(`/game/${name}`);
  };

  const onRank = () => {
    navigate(`/rank/${name}`);
  };

  const onLinkShareHandler = () => {
    alert(t(name) + t("게임 링크가 복사되었습니다!"));
  };

  const total = rank
    ?.map((v) => (v = v.count))
    .reduce((prev, curr) => prev + curr, 0)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return (
    <>
      {data.length === 0 ? (
        <Loading />
      ) : (
        <Content>
          <TitleDiv big={true}>
            <span className="name">&nbsp; '{t(name)}' &nbsp;</span>
            {t("월드컵!")}
          </TitleDiv>
          <TitleDiv>
            {t("총")} {total}
            {t("명이 플레이")}
          </TitleDiv>
          <TitleDiv>
            {t("총")} {data.length}
            {t("개의")} '{t(name)}' {t("사진")}
          </TitleDiv>
          <FlexRow>
            <FlexColumn>
              <ImageDiv pic={data[0]?.url} />
              <ImageDiv pic={data[1]?.url} />
            </FlexColumn>
            <FlexColumn>
              <ImageDiv pic={data[2]?.url} />
              <ImageDiv pic={data[3]?.url} />
            </FlexColumn>
          </FlexRow>
          <Main>
            <MainTitle onClick={onGameStart}>{t("시작하기")}</MainTitle>
            <MainTitle onClick={onRank}>{t("랭킹보기")}</MainTitle>
            <MainTitle onClick={onLinkShareHandler}>
              <SharedURL str="공유하기" name={name} />
            </MainTitle>
          </Main>
        </Content>
      )}
    </>
  );
};

export default Contents;

const ImageDiv = styled.div<{ pic: string }>`
  background-image: url(${(props) => props.pic});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  background-color: var(--white);
  border: 1px solid var(--black);
`;
